module.exports = __webpack_public_path__ + "static/media/character.da1c3b99.svg";